import { getExampleNumber, type CountryCode } from "libphonenumber-js";
import examples from "libphonenumber-js/mobile/examples";
import { countries } from "./countries";

export const PHONE_PLACEHOLDER_FALLBACK = "Phone number";

const toCountryCode = (country?: string): string => {
  const value = country?.trim();
  if (!value) return "";
  if (/^[A-Za-z]{2}$/.test(value)) return value.toUpperCase();
  return (
    countries.find(({ name }) => name.toLowerCase() === value.toLowerCase())
      ?.code ?? ""
  );
};

/** Example phone number in international format for the hotel's country. */
export const getPhonePlaceholder = (country?: string): string => {
  const code = toCountryCode(country);
  if (!code) return PHONE_PLACEHOLDER_FALLBACK;
  try {
    return (
      getExampleNumber(code as CountryCode, examples)?.formatInternational() ??
      PHONE_PLACEHOLDER_FALLBACK
    );
  } catch {
    return PHONE_PLACEHOLDER_FALLBACK;
  }
};
